import { render, staticRenderFns } from "./Liquidacion_Editarv2.vue?vue&type=template&id=0096f848&scoped=true"
import script from "./Liquidacion_Editarv2.vue?vue&type=script&lang=js"
export * from "./Liquidacion_Editarv2.vue?vue&type=script&lang=js"
import style0 from "./Liquidacion_Editarv2.vue?vue&type=style&index=0&id=0096f848&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0096f848",
  null
  
)

export default component.exports